import React from "react";
import classnames from "classnames";
import styles from "./WriteComment.modules.less";
import { article } from "@Api";
import { message } from "antd";
import Cookies from "js-cookie";
import NewLoginModel from "@Components/Comment/NewLoginModel";
import { isEmptyString } from "../../../utils/dataHandler";

const { mobileArticleAddComment } = article;

export interface IProps {
  size?: string;
  placeholder?: string;
  type: string;
  id: string;
  re_id?: string;
  re_mid?: string;
  stylesArea?: any;
  response?: (result: any) => void;
  stylesMargin?: any;
}

const openNotificationWithIcon = (type, msg = "") => {
  // notification[type]({
  //   message: "評論提示",
  //   description: message,
  // });
  message[type](msg);
};

class WriteComment extends React.PureComponent<IProps> {
  public readonly state = {
    isSigIn: false,
    modalOpen: false,
  };
  private textareaRef = React.createRef<HTMLTextAreaElement>();

  private sendComment = async () => {
    let textarea: any = this.textareaRef.current;
    const { type, id, re_id, re_mid, response } = this.props;

    if (textarea.value === "") {
      openNotificationWithIcon("info", "評論內容不能為空");
      return false;
    }

    let params = {
      // token: localStorage.getItem("accesstoken") || Cookies.get("PHPSESSID"),
      type: type,
      id: id,
      re_id: re_id,
      re_mid: re_mid,
      content: textarea.value,
    };

    const result: any = await mobileArticleAddComment({ ...params });

    if (result.status == "ok") {
      openNotificationWithIcon("success", "評論成功");
      textarea.value = "";
      if (response) {
        response(result);
      }
    } else {
      openNotificationWithIcon("error", result.error.message);
    }
  };
  public render() {
    const {
      size = "large",
      placeholder = "發佈你的看法吧",
      stylesArea = { color: "#333" },
      stylesMargin = { color: "#333" },
    }: any = this.props;

    let textarea_classnames = classnames({
      "textarea-large": size == "large",
      "textarea-small": size == "small",
    });

    return (
      <section className={styles["IframeWriteComment"]} style={stylesMargin}>
        <textarea
          className={styles[textarea_classnames]}
          placeholder={placeholder}
          ref={this.textareaRef}
          style={stylesArea}
        />
        <button
          className={styles["send-btn"]}
          onClick={() => {
            let textarea: any = this.textareaRef.current;
            if (textarea && isEmptyString(textarea.value)) {
              openNotificationWithIcon("info", "評論內容不能為空");
              return;
            }
            this.setState({
              modalOpen: true,
            });
          }}
        >
          發佈
        </button>

        <NewLoginModel
          title='發佈評論，與更多用戶交流互動！'
          desc='立即登入，用戶回覆後將同步您'
          visible={this.state.modalOpen}
          onClose={() => {
            openNotificationWithIcon("info", "您已取消登錄，將以遊客身份發佈評論");
          }}
          setVisible={(status) => {
            this.sendComment();
            this.setState({
              modalOpen: status,
            });
          }}
        />
      </section>
    );
  }
}

export default WriteComment;
